import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });

  return (
    <motion.div
      style={{
        position:        "fixed",
        top:              0,
        left:             0,
        right:            0,
        height:           2,
        background:      "linear-gradient(90deg, #ff4757, #ff8fa3)",
        transformOrigin: "0%",
        scaleX,
        zIndex:           200,
        boxShadow:       "0 0 8px #ff4757, 0 0 20px #ff475740",
      }}
    />
  );
}
